import { render, staticRenderFns } from "./AreaDictionary.vue?vue&type=template&id=521f844d&scoped=true"
import script from "./AreaDictionary.vue?vue&type=script&lang=js"
export * from "./AreaDictionary.vue?vue&type=script&lang=js"
import style1 from "./AreaDictionary.vue?vue&type=style&index=1&id=521f844d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "521f844d",
  null
  
)

export default component.exports